export default __webpack_public_path__ + "static/media/b17.92d73bdd.png";